import React from "react";
import "./SkillsInfo.css";

const QInfo = () => {
  return (
    <>
      <p className="skill__key">Q</p>
      <h5 className="skill_name">COMET SPEAR</h5>
      <p className="skill_infos">
        Pantheon either thrusts his spear or throws his spear in the chosen
        directio
      </p>
    </>
  );
};

export default QInfo;
